<!-- close button -->
<button class="pos-absolute z-1 right-0 right-2-s top-2-s p-a cursor-pointer button-icon"
        type="button"
        (click)="close()"
        aria-label="Close modal window">
    <i class="fs-3 icon-close"
       aria-hidden="true"></i>
</button>

<!-- modal contents -->
<ng-content></ng-content>